import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
	name: 'validationMessage'
})

/**
 * ValidationMessagePipe translates validation messages
 *
 * Usage:
 *  key | validationMessage: category
 */
export class ValidationMessagePipe implements PipeTransform
{
	/**
	 * Returns a translated validation message for a given key and category
	 *
	 * @param {string} key
	 * @param {string} category
	 *
	 * @returns {string}
	 */
	transform(key: string, category: string): string
	{
		if (environment.validation[category] && environment.validation[category][key]) {
			return environment.validation[category][key];
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/pipes/validation-message.pipe.ts